import { render, staticRenderFns } from "./TriviaEasy.vue?vue&type=template&id=08611b68&scoped=true&"
import script from "./TriviaEasy.vue?vue&type=script&lang=js&"
export * from "./TriviaEasy.vue?vue&type=script&lang=js&"
import style0 from "./TriviaEasy.vue?vue&type=style&index=0&id=08611b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08611b68",
  null
  
)

export default component.exports